import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScrollService {
  private readonly TAG = 'ScrollService';
  scrollToTop(): void {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  scrollToElementById(id: string, block: ScrollLogicalPosition = 'end') {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: block, inline: 'nearest' });
    } else {
      console.error(`${this.TAG} scrollToElementById id=${id} not found`);
    }
  }
}
